import { css, styled } from '@slal/ui';
import { Input, InputGroup } from '@slal/ui/forms';
import { ErrorIcon } from '@slal/ui/icons';
import { ComboBoxField, TextField as SUITextField, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { Article, P, Text } from '@slal/ui/typography';
import { FieldWrapperProps } from './types';

export const relatedFieldIndent = '44px';

export const StyledForm = styled.form``;

export const StyledFieldSet = styled.fieldset`
    margin: 0 0 ${({ theme }) => theme.space[7]};
    padding: 0;
    border: 0;
`;

export const FieldWrapper = styled.div<FieldWrapperProps>`
    margin-bottom: ${({ theme }) => theme.space[6]};

    > label {
        margin-bottom: ${({ theme }) => theme.space[4]};
        font-family: ${({ theme }) => theme.fonts.sansSerif.family};
        font-size: ${({ theme }) => theme.fontSizes[4]};
        font-weight: 400;
        color: ${({ theme }) => theme.colors.blue__primary__100};
    }

    input[type='checkbox'] {
        margin-right: ${({ theme }) => theme.space[4]};
    }
    ${({ theme, variant }) =>
        variant === 'related' &&
        css`
            margin-top: -${theme.space[7]};
            margin-left: ${relatedFieldIndent};
            > label {
                font-family: ${theme.fonts.sansSerif.family};
                font-weight: ${theme.fonts.sansSerif.fontWeights.regular};
                color: ${theme.colors.neutral__light__70};
            }
        `}
`;

export const ErrorWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.space[3]};
    margin-top: ${({ theme }) => theme.space[4]};
`;

export const FieldErrorMessage = styled(P)`
    margin-top: ${({ theme }) => theme.space[2]};
    color: ${({ theme }) => theme.colors.danger};
    font-size: ${({ theme }) => theme.fontSizes[3]};
`;

export const StyledErrorIcon = styled(ErrorIcon)`
    color: ${({ theme }) => theme.colors.danger};
    margin-right: ${({ theme }) => theme.space[3]};
`;

export const StyledSubmitButtonWrapper = styled.div`
    display: flex;
    margin-top: ${({ theme }) => theme.space[7]};
    padding-bottom: ${({ theme }) => theme.space[7]};
`;

export const StyledFieldHelp = styled(Text)`
    display: block;
    margin-top: ${({ theme }) => theme.space[4]};
    font-size: ${({ theme }) => theme.fontSizes[3]};
    font-family: ${({ theme }) => theme.fonts.sansSerif.family};
    font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
`;

StyledFieldHelp.defaultProps = {
    tag: 'span',
};

export const StyledFormIntroduction = styled(Article)`
    margin-bottom: ${({ theme }) => theme.space[5]};
    p {
        margin-top: -${({ theme }) => theme.space[5]};
    }
`;

const getSize = (size?: number) => {
    if (!size) return '100%';
    switch (size) {
        case 5:
            return '370px';
        case 4:
            return '80px';
        case 3:
            return '68px';
        case 2:
            return '56px';
        default:
            return '44px';
    }
};

export const StyledInput = styled(Input)`
    width: ${({ size }) => getSize(size)};
    margin-right: ${({ size, theme }) => (size ? theme.space[4] : '0')};
`;

export const StyledDateFieldSet = styled(StyledFieldSet)`
    padding-top: ${({ theme }) => theme.space[2]};
    margin: 0;
    label {
        margin-bottom: ${({ theme }) => theme.space[4]};
        font-size: inherit;
        font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
    }
`;

export const TextField = styled(SUITextField)`
    max-width: ${({ size }) => getSize(size)} !important;
`;

export const StyledCombobox = styled(ComboBoxField)`
    max-width: 370px !important;
`;

export const StyledRadioGroup = styled(RadioFieldGroup)`
    padding-left: 8px;
`;

export const StyledInputGroup = styled(InputGroup)`
    width: 134px;
    margin-right: 16px;
    label {
        font-family: ${({ theme }) => theme.fonts.sansSerif.family};
        font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
        font-size: ${({ theme }) => theme.fontSizes[6]};
        padding: 0 14px;
    }
    input {
        min-width: 50px !important;
    }
`;
